import React, { useState, useCallback, } from "react";

import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock } from "./styles";
import { systemLogs } from "../../../../services/system_logs";

const ReportFirstContact = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [loading, setLoading] = useState(false);
  const [relatorio, setRelatorio] = useState(false);

  const handleGenerateReport = useCallback(async () => {
    setLoading(true);
    setRelatorio(false);

    try {
      const res = await producaov2.post("/admin/reports/first-contact", {
        data_inicio: dataInicio,
        data_final: dataFinal,
      });

      setRelatorio(res.data.url);
      setLoading(false);

      await systemLogs(
        "Relatorio",
        `Gerou o relatorio de Primeiro Contato entre ${dataInicio} e ${dataFinal}}`
      );

      swal("Confirmado!", "Relatório gerado com sucesso", "success");

      window.open(res.data.url, "blank");
    } catch (error) {
      console.log(error);

      setLoading(false);

      if (!error.response) {
        return;
      }

      swal(`Algo deu errado`, `Se persistir, contate nosso suporte`, "error");
    }
  }, [dataInicio, dataFinal]);

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container>
        <Header>Relatório de Primeiro Contato</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>

            <FormGroup>
              <Button
                color="orange"
                onClick={handleGenerateReport}
                loading={loading}
              >
                Gerar Relatório
              </Button>
              {relatorio && (
                <Button
                  style={{ minWidth: "80px" }}
                  onClick={() => window.open(relatorio, "_blank")}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default ReportFirstContact;
